"use strict";
function rgbaString(rgba) {
    return 'rgba(' + rgba.join(',') + ')';
}
exports.rgbaString = rgbaString;
//# sourceMappingURL=rgbaString.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rainbow-color/~/color-map/dist/commonjs/rgbaString.js
// module id = 1122
// module chunks = 0